import { render, staticRenderFns } from "./SalesByDayName.vue?vue&type=template&id=0aa1d0c5&"
import script from "./SalesByDayName.vue?vue&type=script&lang=js&"
export * from "./SalesByDayName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports